import UnsavedChangesConfirmationModal from './UnsavedChangesConfirmationModal';

export default UnsavedChangesConfirmationModal;
